// Module
var code = "<template>\n    <require from=\"./spinner.scss\"></require>\n    <div class=\"spinner-ctr\">\n        <div class=\"spinner\"></div>\n    </div>\n  </template>\n  ";
// Exports
export default code;